import { useEffect } from 'react'
import { useAuth } from './AuthProvider'
import { clearAuthRedirectUrl, getAuthRedirectUrl } from './util/login'
import type { Auth0Session } from './util/session'

export default function useAuthCallback(
  onAuthenticated: (err: auth0.Auth0Error, session: Auth0Session, previousUrl: string) => any
) {
  const { handleRedirectCallback } = useAuth()

  useEffect(() => {
    const previousUrl = getAuthRedirectUrl()

    handleRedirectCallback()
      .then(async (sessionResult) => {
        if (onAuthenticated) {
          onAuthenticated(null, sessionResult, previousUrl)
        }

        clearAuthRedirectUrl()
      })
      .catch((err) => {
        // clear on failure too — this path reports previousUrl as null, so leaving the
        // value behind would only let it hijack an unrelated later login
        clearAuthRedirectUrl()

        if (onAuthenticated) {
          onAuthenticated(err, null, null)
        }
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
